import React, { FunctionComponent } from "react";

const HOTWTile: FunctionComponent = () => {
	const handleCoinClick = (e: React.MouseEvent<HTMLButtonElement>) => {
			var videoModal = document.getElementById("hotw-modal");
			const url = new URL(window.location.href);
			url.searchParams.set("homes", "hotw");
			url.searchParams.set("video", "hotw");
			window.history.pushState(null, null, url);
	
			videoModal.setAttribute("style", "display: block");
			document.body.classList.add("modal-open");
		}

	return (
		<div className="hotw-title-tile">
			<div className="hotw-banner">
				<div className="coin-container">
					<button aria-label="Watch video about homes of the week" className="hotw-wrapper hotw-tile" onClick={(e) => handleCoinClick(e)}>
						<img className="hotw-coin" src="/-/media/hotw_coin_flat.png" />
						<div className="hotw-coin-shadow"></div>
					</button>
				</div>
				<div className="hotw-banner-descr">
					<h2>Homes of the week</h2>
					<p>Our favorite house can be your new home. Schedule a tour today.</p>
				</div>
			</div>
		</div>
    );
};

export default HOTWTile;